import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { routers } from 'router/router';
import counselorServices from 'services/counselorServices';
import { getUserId } from 'utils/sessionStorage';

const HomePage = () => {
  const history = useHistory();

  useEffect(() => {
    const role = sessionStorage.getItem('userRole');
    if (role !== 'counselor') return;

    let cancelled = false;
    (async () => {
      const uid = getUserId();
      if (!uid) return;
      try {
        const res = await counselorServices.getPartner(uid);
        const firstId = res?.[0]?.student_id;
        if (cancelled || !firstId) return;
        history.replace(routers.viewStudent.path.replace(':id', String(firstId)));
      } catch {
        // stay on empty page
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [history]);

  return <></>;
};

export default HomePage;
